import { DocumentUpload } from "iconsax-react";
import CancelButton from "../../components/CancelButton/CancelButton";
import CreateButton from "../../components/CreateButton/CreateButton";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { Category } from "../../redux/slices/categorySlice";
import axios from "axios";
import {
  createFoodWithImage,
  setError,
} from "../../redux/slices/addNewFoodSlice";
import { createDailyOffer } from "../../redux/slices/addNewDailyOffer";
import ErrorModal from "../../components/ErrorModal/ErrorModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Image } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";
import { AsyncPaginate } from "react-select-async-paginate";
import top from "../../assets/Status bar.png";
import heart from "../../assets/Vector.png";
import FoodPreview from "../../components/FoodPreview/FoodPreview";
import { useTranslation } from "react-i18next";

type Props = {};

const KrijoMenu = (props: Props) => {
  const categoryDropdownRef = useRef<HTMLDivElement | null>(null);
  const restaurant = useSelector((state: RootState) => state.restaurantProfile);
  const { error } = useSelector((state: RootState) => state.addNewFood);
  const { t } = useTranslation();

  const dispatch = useDispatch<AppDispatch>();
  const [isSelected, setIsSelected] = useState<string>(
    () => localStorage.getItem("selectedTab") || "tegjitha"
  );

  const [categories, setCategories] = useState<Category[]>([]);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<number[]>([]);

  const [foodName, setFoodName] = useState<string>("");
  const [price, setPrice] = useState<number | string>("");
  const [image, setImage] = useState<File | null>(null);

  const [imageName, setImageName] = useState<string>("");

  const [title, setTitle] = useState<string>("");

  const [showModal, setShowModal] = useState(false);

  const foodPreview = (
    <FoodPreview
      image={image}
      foodName={isSelected === "tegjitha" ? foodName : title}
      price={price}
      phoneNumber={restaurant.phoneNumber}
      location={restaurant.location}
      restaurantName={restaurant.name}
      top={top}
      heart={heart}
      category={
        isSelected === "tegjitha" && selectedCategory.length > 0
          ? selectedCategory
              .map(catId => {
                const found = categories.find(cat => cat.id === catId);
                return found ? found.name : "";
              })
              .filter(name => name !== "") 
          : []
      }
    />
  );  

  const loadCategoryOptions = async (
    search: string,
    loadedOptions: any,
    { page }: any
  ) => {
    const token = localStorage.getItem("token");
    const isSearching = search && search.length > 0;

    const endpoint = isSearching
      ? `https://dev.api.jomuntu.com/api/v1/categories/search-by-name`
      : `https://dev.api.jomuntu.com/api/v1/categories`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: isSearching ? { name: search } : { size: 10, page },
      });

      const categories = isSearching ? response.data : response.data.content;

      const options = categories.map((category: Category) => ({
        label: category.name,
        value: category.id,
      }));

      return {
        options,
        hasMore: !isSearching && !response.data.last,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      console.error("Failed to load categories:", error);
      return {
        options: [],
        hasMore: false,
      };
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        categoryDropdownRef.current &&
        !categoryDropdownRef.current.contains(event.target as Node)
      ) {
        setIsCategoryOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    async function fetchData() {
      const token = localStorage.getItem("token");
      try {
        const categoriesResponse = await axios.get(
          "https://dev.api.jomuntu.com/api/v1/categories?size=100",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCategories(categoriesResponse.data.content);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchData();
  }, []);

  const handleTabClick = (tab: string) => {
    setFoodName("");
    setPrice("");
    setSelectedCategory([]);
    setImage(null);
    setTitle("");
    setImageName("");
  
    setIsSelected(tab);
    localStorage.setItem("selectedTab", tab);
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const selectedImage = e.target.files[0];
      setImage(selectedImage);
      setImageName(selectedImage.name);
    }
  };

  const handleSubmitFood = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!foodName.trim() || !price || selectedCategory.length === 0 || !image) {
      setShowModal(true);
      dispatch(setError(t("error.allFieldsRequired")));
      return;
    }

    // let errors: string[] = [];

    // if (!foodName.trim()) {
    //   errors.push(t("error.foodNameRequired"));
    // }
    
    // if (!price) {
    //   errors.push(t("error.priceRequired"));
    // }
    
    // if (selectedCategory.length === 0) {
    //   errors.push(t("error.categoryRequired"));
    // }
    
    // if (!image) {
    //   errors.push(t("error.imageRequired"));
    // }
    
    // if (errors.length > 0) {
    //   setShowModal(true);
    //   dispatch(setError(errors.join(", ")));
    //   return;
    // }


    try {
      const foodData = {
        foodName,
        price,
        categoryIds: selectedCategory,
      };

      await dispatch(createFoodWithImage(foodData, image));

      setFoodName("");
      setPrice("");
      setSelectedCategory([]);
      setImage(null);
    } catch (error) {
      console.error("Error creating food item:", error);
    }
  };

  const handleCancelFood = () => {
    setFoodName("");
    setPrice("");
    setSelectedCategory([]);
    setImage(null);
  };

  useEffect(() => {
    if (error) {
      setShowModal(true);
      dispatch(setError(error));
    }
  }, [error, dispatch]);
  
  const handleModalClose = () => {
    setShowModal(false);
    dispatch(setError(null));
  };

  // OFERTAT

  const handleSubmitFOffer = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!title.trim() || !price || !image) {
      setShowModal(true);
      dispatch(setError(t("Ju lutem plotësoni të gjitha fushat për ushqimin.")));
      return;
    }
    try {
      const offerData = {
        title,
        price,
      };

      await dispatch(createDailyOffer(offerData, image));

      setTitle("");
      setPrice("");
      setImage(null);
      setImageName("");
    } catch (error) {
      console.error("Error creating daily offer:", error);
    }
  };

  const handleCancelOffer = () => {
    setTitle("");
    setPrice("");
    setImage(null);
  };

  return (
    <div className="w-full">
      <ToastContainer />
  
      <div className="flex gap-2">
        <button
          className={`w-[155px] h-[36px] rounded-lg text-sm ${
            isSelected === "tegjitha"
              ? "bg-customBrown text-white"
              : "bg-white text-black"
          }`}
          onClick={() => handleTabClick("tegjitha")}
        >
          {t("krijomenu.allFoods")}
        </button>
        <button
          className={`w-[155px] h-[36px] rounded-lg text-sm ${
            isSelected === "ofertat"
              ? "bg-customBrown text-white"
              : "bg-white text-black"
          }`}
          onClick={() => handleTabClick("ofertat")}
        >
          {t("krijomenu.dailyOffers")}
        </button>
      </div>
  
      <div className="flex w-full gap-6 pt-6">
        <div className="w-full md:w-2/3">
          {isSelected === "tegjitha" ? (
            <div>
              {showModal && (
                <ErrorModal message={error} onClose={handleModalClose} />
              )}
              <form onSubmit={handleSubmitFood}>
                <div className="pt-11">
                  <h2 className="text-2xl font-medium">
                    {t("krijomenu.addNewFoodTitle")}
                  </h2>
                  <p className="text-sm">
                    {t("krijomenu.addNewFoodDescription")}
                  </p>
                </div>
                <div className="flex flex-col gap-1 pt-8">
                  <label className="text-sm font-medium">
                    {t("krijomenu.foodImage")} <span className="text-red-600">*</span>
                  </label>
                  {!image ? (
                    <label className="w-full border-2 h-[124px] rounded-md border-dashed border-borderColor flex flex-col justify-center items-center cursor-pointer hover:border-[#D10000]">
                      <div className="flex justify-center p-2 rounded-full bg-gray-50">
                        <DocumentUpload color="#D10000" />
                      </div>
                      <h1>
                        <span className="font-medium text-[#D10000]">
                          {t("krijomenu.clickToUpload")}
                        </span>{" "}
                        {t("addFood.orDrag")}
                      </h1>
                      <h1 className="text-sm">{t("krijomenu.maxFileSize")}</h1>
                      <input
                        type="file"
                        onChange={handleImageChange}
                        name="file_upload"
                        className="hidden"
                        id="image"
                      />
                    </label>
                  ) : (
                    <div className="relative mt-2 px-4 py-3 rounded-md bg-gray-100 border border-gray-300 flex items-center justify-between max-w-[400px]">
                      <div className="flex items-center gap-2">
                        <div className="p-2 rounded-full bg-customOrange/10">
                          <DocumentUpload color="#D10000" />
                        </div>
                        <span className="text-sm text-gray-700 break-all">
                          {image.name}
                        </span>
                      </div>
                      <CloseCircleFilled
                        onClick={() => {
                          setImage(null);
                          setImageName("");
                        }}
                        className="text-red-500 text-lg cursor-pointer hover:text-red-600"
                      />
                    </div>
                  )}
                </div>
                <div className="flex gap-3 pt-8">
                  <div className="flex flex-col w-4/12 gap-1">
                    <label className="text-sm font-medium">
                      {t("krijomenu.foodName")} <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      value={foodName || ""}
                      onChange={(e) => setFoodName(e.target.value)}
                      placeholder={t("krijomenu.foodNamePlaceholder")}
                      className="border h-[40px] rounded-md pl-4 text-sm focus:border-2 focus:outline-none leading-[40px]"
                    />
                  </div>
                  <div className="flex flex-col w-4/12 gap-1">
                    <label className="text-sm font-medium">
                      {t("krijomenu.category")} <span className="text-red-600">*</span>
                    </label>
                    <AsyncPaginate
                      isMulti
                      placeholder={t("krijomenu.selectCategory")}
                      value={selectedCategory
                        .map((id) => {
                          const found = categories.find((c) => c.id === id);
                          return found
                            ? { label: found.name, value: found.id }
                            : null;
                        })
                        .filter(Boolean)}
                      loadOptions={loadCategoryOptions}
                      additional={{ page: 0 }}
                      onChange={(selectedOptions) => {
                        const selectedIds = selectedOptions.map(
                          (option: any) => option.value
                        );
                        setSelectedCategory(selectedIds);
                      }}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "40px",
                          fontSize: "14px",
                          borderColor: "#e5e7eb",
                          borderRadius: "0.375rem",
                        }),
                      }}
                    />
                  </div>
                  <div className="flex flex-col w-4/12 gap-1">
                    <label className="text-sm font-medium">
                      {t("krijomenu.price")} <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      value={price || ""}
                      onChange={(e) => setPrice(e.target.value)}
                      placeholder="$"
                      className="border h-[40px] rounded-md pl-4 text-sm focus:border-2 focus:outline-none leading-[40px]"
                    />
                  </div>
                </div>
                <div className="flex gap-3 pt-8">
                  <div className="flex flex-col w-6/12 gap-1">
                    <label className="text-sm font-medium">
                      {t("krijomenu.address")} <span className="text-red-600">*</span>
                    </label>
                    <input
                      readOnly
                      type="text"
                      value={restaurant.location}
                      placeholder={t("krijomenu.address")}
                      className="border h-[40px] rounded-md pl-4 text-sm focus:border-2 focus:outline-none leading-[40px]"
                    />
                  </div>
                  <div className="flex flex-col w-6/12 gap-1">
                    <label className="text-sm font-medium">
                      {t("krijomenu.phone")} <span className="text-red-600">*</span>
                    </label>
                    <input
                      readOnly
                      type="text"
                      value={restaurant.phoneNumber}
                      placeholder="+383 //////"
                      className="border h-[40px] rounded-md pl-4 text-sm focus:border-2 focus:outline-none leading-[40px]"
                    />
                  </div>
                </div>
                <div className="flex justify-end w-full gap-2 pt-24">
                  <CreateButton
                    label={t("krijomenu.sendForConfirmation")}
                    className="w-[236px]"
                  />
                  <CancelButton onClick={handleCancelFood} />
                </div>
              </form>
            </div>
          ) : isSelected === "ofertat" ? (
            <div>
              {showModal && (
                <ErrorModal message={error} onClose={handleModalClose} />
              )}
              <form onSubmit={handleSubmitFOffer}>
                <div className="pt-11">
                  <h2 className="text-2xl font-medium">
                    {t("krijomenu.addNewOfferTitle")}
                  </h2>
                  <p className="text-sm">
                    {t("krijomenu.addNewOfferDescription")}
                  </p>
                </div>
                <div className="flex flex-col gap-1 pt-8">
                  <label className="text-sm font-medium">
                    {t("krijomenu.foodImage")} <span className="text-red-600">*</span>
                  </label>
                  {!image ? (
                    <label className="w-full border-2 h-[124px] rounded-md border-dashed border-borderColor flex flex-col justify-center items-center cursor-pointer hover:border-[#D10000]">
                      <div className="flex justify-center p-2 rounded-full bg-gray-50">
                        <DocumentUpload color="#D10000" />
                      </div>
                      <h1>
                        <span className="font-medium text-[#D10000]">
                          {t("krijomenu.clickToUpload")}
                        </span>{" "}
                        {t("addFood.orDrag")}
                      </h1>
                      <h1 className="text-sm">{t("krijomenu.maxFileSize")}</h1>
                      <input
                        type="file"
                        onChange={handleImageChange}
                        name="file_upload"
                        className="hidden"
                        id="image"
                      />
                    </label>
                  ) : (
                    <div className="relative mt-2 px-4 py-3 rounded-md bg-gray-100 border border-gray-300 flex items-center justify-between max-w-[400px]">
                      <div className="flex items-center gap-2">
                        <div className="p-2 rounded-full bg-customOrange/10">
                          <DocumentUpload color="#D10000" />
                        </div>
                        <span className="text-sm text-gray-700 break-all">
                          {image.name}
                        </span>
                      </div>
                      <CloseCircleFilled
                        onClick={() => {
                          setImage(null);
                          setImageName("");
                        }}
                        className="text-red-500 text-lg cursor-pointer hover:text-red-600"
                      />
                    </div>
                  )}
                </div>
                <div className="flex gap-3 pt-8">
                  <div className="flex flex-col w-6/12 gap-1">
                    <label className="text-sm font-medium">
                      {t("krijomenu.offerName")} <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      value={title || ""}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder={t("krijomenu.offerNamePlaceholder")}
                      className="border h-[40px] rounded-md pl-4 text-sm focus:border-2 focus:outline-none leading-[40px]"
                    />
                  </div>
                  <div className="flex flex-col w-6/12 gap-1">
                    <label className="text-sm font-medium">
                      {t("krijomenu.price")} <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      onChange={(e) => setPrice(e.target.value)}
                      placeholder="$"
                      className="border h-[40px] rounded-md pl-4 text-sm focus:border-2 focus:outline-none leading-[40px]"
                    />
                  </div>
                </div>
                <div className="flex gap-3 pt-8">
                  <div className="flex flex-col w-6/12 gap-1">
                    <label className="text-sm font-medium">
                      {t("krijomenu.address")} <span className="text-red-600">*</span>
                    </label>
                    <input
                      readOnly
                      type="text"
                      value={restaurant.location}
                      placeholder={t("krijomenu.address")}
                      className="border h-[40px] rounded-md pl-4 text-sm focus:border-2 focus:outline-none leading-[40px]"
                    />
                  </div>
                  <div className="flex flex-col w-6/12 gap-1">
                    <label className="text-sm font-medium">
                      {t("krijomenu.phone")} <span className="text-red-600">*</span>
                    </label>
                    <input
                      readOnly
                      type="text"
                      value={restaurant.phoneNumber}
                      placeholder="+383 //////"
                      className="border h-[40px] rounded-md pl-4 text-sm focus:border-2 focus:outline-none leading-[40px]"
                    />
                  </div>
                </div>
                <div className="flex justify-end w-full gap-2 pt-24">
                  <CreateButton
                    label={t("krijomenu.sendForConfirmation")}
                    className="w-[236px]"
                  />
                  <CancelButton onClick={handleCancelOffer} />
                </div>
              </form>
            </div>
          ) : null}
        </div>
        {foodPreview}
      </div>
    </div>
  );
};

export default KrijoMenu;
